// 新版候选人结构
import request from "@/lib/request/request";
import Model from "../../model";
import {
  EnumCallbackStatus,
  EnumSubmitStatus,
  EnumMessageStatus,
  EnumCostStatus,
  EnumCandidateJoinStatus,
  EnumOutLinkStatus,
  EnumProcessStatus,
  EnumAiRecommendStatus,
  EnumAuditStatus,
  EnumErrorInfoTask,
  EnumCandidateListSortKey
} from "./candidate-v3-enum";
import Auth from "@/lib/common/auth";
import CandidateRepeatCreateForm from "@/lib/form/candidate/CandidateRepeatCreateForm";
import { RepeatMCreate } from "@/lib/form/candidate/CandidateMRepeatCreateForm";
import CandidateListForm from "@/lib/form/candidate/CandidateListForm";

// 用户-uc
export class StructUser extends Model {
  userId = 0;
  email = "";
  threatDegree = 0; // 权限等级
  nickname = "";
  mobile = "";
  avatarUrl = ""; // 头像地址
  role = 0;
  departmentNo = ""; // 管理范围
}

export class BgBuy extends Model {
  afterBuy = 0;
  financialRisk = 0;
  identityInfo = 0;
  productId = 0;
  socialInfo = 0;
}

// 背调
export class BG extends Model {
  bgCheckStatus = 0;
  errorMessage = "";
  financialRiskStatus = 0;
  identityInfoStatus = 0;
  product = new BgBuy();
  requestId = 0;
  socialInfoStatus = 0;
  status = 0;
  socialInfoErrorLevel: number | null = null;
  financialRiskErrorLevel: number | null = null;
}

class ReplaceCheckResult extends Model {
  result = 0; //0不足 1异常 2正常
  imgList: string[] = [""];
}

class FaceDetectionResult extends Model {
  result = 0; //0不足 1异常 2正常
  imgList: string[] = [""];
  failNumber = ""; // 无人脸图片数
  totalNumber = ""; // 全部图片数
}

class CandidateV3Numbers extends Model {
  submitStatusFinishAuditStatusNoAudit = 0;
}

//心理结果
export class MindResult extends Model {
  afterHr = 0; //经过hr修改
  depressiveTestResultAdmin = 0;
  depressiveTestResultAi = 0;
  depressiveTestResultChoice = 0;
  depressiveTestResultHr = 0;
  violentTestResultAdmin = 0;
  violentTestResultAi = 0;
  violentTestResultChoice = 0;
  violentTestResultHr = 0;
  //友达光电新字段
  ydgdJsb = 0; //友达光电 精神病
  ydgdCd = 0; //冲动性
  ydgdSh = 0; //说谎性
  ydgdJsbResText = ""; //结果文案
  ydgdCdResText = ""; //结果文案
  ydgdShResText = ""; //结果文案
  //通用字段
  depressive = 0; //抑郁
  depressiveResText = "";
  violent = 0; //暴力
  violentResText = "";
}

export class ErrorInfo extends Model {
  task = EnumErrorInfoTask.EnumErrorInfoTaskDefault; //考察项名称
  result = 0; //1异常 其他正常
  resMessage = ""; //结果文案
}

export class StructParam {
  paramId?: 0;
  type = 0;
  isShow = 0;
  isRequired = 0;
  inputType = "";
  sort = 0;
  extraData = "";
  name = "";
  value = "";
  aliasName = ""; //别名
  cascadeValue = "";
}

class StructCandidateCoderLink extends Model {
  coderOutId = 0;
  coderConnectUrl = "";
  submitStatus = 0;
  message = ";";
}

// 候选人item
export class CandidateV3Item extends Model {
  examName = ""; // 面试名称
  examRemark = ""; // 面试备注
  subExamName = ""; // 子面试名称
  examHideAiScore = 0; // 隐藏ai得分配置
  examIsHrScore = 0; // 阅卷页是否使用HR印象分逻辑
  examMobileJoinCountCheck = 0; // 是否小程序跳出检测
  screenshotCheck = 0; // 是否小程序截屏检测
  examType = "aibuilder"; // 面试类型新版写死即可
  markCallbackStatus = EnumCallbackStatus.EnumCallbackStatusDefault; // 已出分未评价回调状态
  isRepeatExam = 0; // 是否是单公司跨面试重复
  isRepeatExamCount = 0; // 单公司跨面试重复次数
  positionId = 0; // 岗位id
  positionName = ""; // 岗位名

  candidateId = 0; // 候选人id
  connectCode = ""; // 链接码
  examId = 0; // 面试id
  examVersionId = 0; // 面试批次id
  subExamId = 0; // 子面试id
  companyId = 0; // 公司id
  userId = 0; // 负责人用户id
  user = new StructUser(); // 负责人信息
  createdTime = ""; // 创建时间
  beginTime = ""; // 开始答题时间
  submitTime = ""; // 提交答题时间
  loginTime = ""; // 登记时间
  lastOperationTime = ""; // 末次操作时间
  submitStatus = EnumSubmitStatus.EnumSubmitStatusNotSignIn; // 提交状态
  isAutoSubmit = 0; // 是否自动提交
  isAutoExpire = 0; // 是否自动过期
  isEmptyReport = 0; // 是否属于已交卷未作答（白卷）
  submitType = ""; // 提交类型
  messageStatus = EnumMessageStatus.EnumMessageStatusOpenLink; // 通知状态
  costStatus = EnumCostStatus.EnumCostStatusNormal; // 付款状态
  joinStatus = EnumCandidateJoinStatus.EnumCandidateJoinStatusDefault; // 候选人加入状态
  outLinkStatus = EnumOutLinkStatus.EnumOutLinkStatusNormal; // 外链关系状态
  aiProcessStatus = EnumProcessStatus.EnumProcessStatusNormal; // ai执行状态
  isRepeatCreate = 0; // 是否重复邀请逻辑创建
  isRepeatCompany = 0; // 是否全公司下重复
  isRepeat = 0; // 是否单面试下重复
  isRepeatCount = 0; // 单面试下重复次数
  answerNumber = 0; // 总答题次数
  curAnswerNumber = 0; // 当前答题次数
  scoreAi = 0; // ai打分
  score = 0; // 总得分
  scoreHrTotal = 0; // hr印象分
  aiRecommendStatus = EnumAiRecommendStatus.EnumAiRecommendStatusDefault; // ai推荐状态
  auditStatus = EnumAuditStatus.EnumAuditStatusNoAudit; // 评估状态
  auditStatusAi = EnumAuditStatus.EnumAuditStatusNoAudit; // 评估状态ai
  auditDesc = ""; // 评估评价
  auditDescAi = ""; // 评估评价ai
  auditTime = ""; // 评估时间
  auditTimeAi = ""; // 评估时间ai
  auditMember = ""; // 评估人员
  auditReason = ""; // 阅卷原因
  mobileJoinCountCheckNumber = 0; // 跳出检测
  screenshotCheckNumber = 0; // 截屏检测
  bgCheckResult = new BG(); // 背调结果
  replaceCheckResult = new ReplaceCheckResult(); // 换人检测详情
  faceDetectionResult = new FaceDetectionResult(); // 露脸检测详情
  testExamResultData = new MindResult(); // 应该用不到
  photoUrl = ""; // 头像链接
  attachmentUrl = ""; // 附件链接
  remark = ""; // 备注
  tags = [""]; // 默认标签/其他标签
  tagsInvite = [""]; // 邀请标签
  tagsAudit = [""]; // 评估标签
  TagsRule = [""]; // 自动化标签
  coderLink = new StructCandidateCoderLink(); // 笔试
  resultData = ""; // 面试结果页手机信息
  errorInfoList = [new ErrorInfo()]; // 异常检测项
  showName = ""; // 姓名
  phone = ""; // 电话
  email = ""; // 邮件
  shortIdNumber = ""; // 身份证后6位
  idNumber = ""; // 身份证号
  paramList = [new StructParam()]; // 登记信息
  paramKvMap = null; // 目前没用过

  aiComment = ""; // ai评价
}

export default class CandidateV3Custom extends Model {
  numbers = new CandidateV3Numbers(); // 人数统计（旧）
  list = [new CandidateV3Item()];
  count = 0;
  page = 0;
  pageSize = 0;
  pageMax = 0;

  //获取题库试题List
  static get(params: CandidateListForm, url = "aiExam/candidate/list") {
    if (params.pageSize == undefined) params.pageSize = 10;

    return request.post(url, params, true).then(resp => {
      return new CandidateV3Custom().assign(resp.data.data);
    });
  }

  // 编辑备注
  static saveRemark(params: CandidateV3RemarkReq) {
    return request.post("/aiExam/candidate/saveRemark", params).then(() => {
      return {};
    });
  }

  //新版发送邀请通知 固定双发
  static sendAsk(params: CandidateGet, env: number) {
    return request
      .post("aiExam/message/candidateSend", {
        ...params,
        env,
        sendMobile: true,
        sendEmail: true
      })
      .then(resp => {
        return resp.data;
      });
  }
  //新版发送通知 固定双发
  static mSendAsk(params: MDelete, env: number) {
    return request
      .post("aiExam/message/candidateMSend", {
        ...params,
        env: env,
        sendMobile: true,
        sendEmail: true
      })
      .then(resp => {
        return resp.data;
      });
  }
  //新版发送结果通知 固定双发
  static sendRes(params: CandidateGet) {
    return request
      .post("aiExam/message/candidateSend", {
        ...params,
        env: 10,
        sendMobile: true,
        sendEmail: true
      })
      .then(resp => {
        return resp.data;
      });
  }

  // 重复邀请单个
  static candidateRepeatCreate(repeatForm: CandidateRepeatCreateForm) {
    return request
      .post("aiExam/candidate/repeatCreate", repeatForm)
      .then(resp => {
        return resp.data;
      });
  }
  // 重复邀请多个
  static repeatMCreate(repeatMCreate: RepeatMCreate) {
    return request
      .post("/aiExam/candidate/repeatMCreate", repeatMCreate)
      .then(resp => {
        return resp.data;
      });
  }
}

export class CandidateV3Req extends Model {
  companyId = 0; // 公司id
  examId = 0; // 查询单场面试 否则查询全部公司下面试
  examType = "aibuilder"; // 面试类型
  subExamId = 0; // 子面试id
  candidateIdList: number[] = []; // 仅查询指定id的候选人
  showNameOrPhone = ""; // 姓名或电话或链接码或身份证号或备注(等于)
  phone = ""; // 仅手机号筛选
  positionId = 0; // 岗位id
  tagNameList: string[] = []; // 标签筛选
  aiRecommendStatusList: EnumAiRecommendStatus[] = []; // AI推荐状态筛选
  submitStatusList: EnumSubmitStatus[] = []; // 提交状态筛选
  auditStatusList: EnumAuditStatus[] = []; // 阅卷状态筛选
  searchUserIdList: number[] = []; // 定向邀请用户id筛选
  createdTime: string[] = []; // 创建时间筛选
  beginTime: string[] = []; // 开始面试时间筛选
  submitTime: string[] = []; // 面试完成时间筛选
  afterBuy = 0; // 是否只搜索购买后的成员
  outLinkStatusList: EnumOutLinkStatus[] = []; // 外链关系状态筛选
  markCallbackStatusList: EnumCallbackStatus[] = []; // 已交卷已出分未评价回调状态筛选
  sortKey: EnumCandidateListSortKey | "" = ""; // 指定排序键
  sortDict: "asc" | "desc" | "" = ""; // 指定排序方向
  page = 1;
  pageSize = 10;
}

export class CandidateV3RemarkReq extends Model {
  companyId = Auth.companyId;
  candidateId = 0;
  remark = "";
}

export class CandidateGet extends Model {
  candidateId = 0;
  companyId = Auth.companyId;
}

export class MDelete extends Model {
  companyId = Auth.companyId;
  candidateIdList: number[] = [];
}
